const initialProps = {
  ticketsDetalle: [],
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "CREATE_TICKETS_DETALLE":
      return {
        ...state,
        ticketsDetalle: action.payload,
      };
    case "UPDATE_TICKETS_DETALLE":
      return {
        ...state,
        ticketsDetalle: action.payload,
      };
    default:
      return state;
  }
}
